import AgentScript from 'components/AgentScript/AgentScript';

const HardshipEligibilityScript = ({ hasAutopay = false }) => {
  return (
    <AgentScript
      title={`STARR Program ${hasAutopay ? '(enrolled in AutoPay)' : ''}`}
      translateKey={
        hasAutopay
          ? 'hardship.withAutopayScript'
          : 'hardship.withoutAutopayScript'
      }
    />
  );
};

export default HardshipEligibilityScript;
